import React, { useState, useEffect } from 'react';
import { navigate } from 'hookrouter';
import { Layout } from '../components/Layout';
import { useTranslation } from 'react-i18next';
import { GENERAL_ERROR_AUTH_MESSAGE, REDIRECTION_ERROR_MESSAGE_PART_ONE, REDIRECTION_ERROR_MESSAGE_PART_TWO, REDIRECTION_MESSAGE } from '../i18n/keyConstants';

const AuthorizationFailure = () => {
    const [counter, setCounter] = useState(10);
    const { t } = useTranslation('errorMessages');

    useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);

        if (counter === 0) {
            navigate('/Account/SignOut');
            window.location.reload();
        }
    }, [counter]);

    return (
        <Layout>
            <div className='text-center padding-top-60px'>
                <h2>{t(GENERAL_ERROR_AUTH_MESSAGE)}</h2>
                <p>
                    {t(REDIRECTION_ERROR_MESSAGE_PART_ONE)}{' '}
                    <a href='mailto:alltid@consid.se' target='_blank' rel='noopener noreferrer'>
                        alltid@consid.se
                    </a>{' '}
                    {t(REDIRECTION_ERROR_MESSAGE_PART_TWO)}
                </p>
                <p className='c-black'>
                    {t(REDIRECTION_MESSAGE)}<strong>{counter}</strong>
                </p>
            </div>
        </Layout>
    );
};

export default AuthorizationFailure;
